import { ProgressTableSkillsValue } from '../components/Progress/QuerySkillsProgressReport';
import { ProgressTableStudentsValue } from '../components/Progress/QueryStudentsProgressReport';
import { ProgressType } from '../models/CsvExport';
import { createAndExportCSV } from './createAndExportGenericCSV';

interface TransformedData {
  Name: string;
  'Skill type'?: string;
  'Not Started': number;
  'Keep Learning': number;
  'Almost There': number;
  Passed: number;
  'Placed Out': number;
  Review: number;
}

type SkillResultKey = 'Not Started' | 'Keep Learning' | 'Almost There' | 'Passed' | 'Placed Out' | 'Review';

export const transformDataProgressStudentTable = (data: ProgressTableStudentsValue[]): TransformedData[] => {
  return data.map(item => {
    const result: TransformedData = {
      Name: `${item.studentLastName} ${item.studentFirstName}`,
      'Not Started': 0,
      'Keep Learning': 0,
      'Almost There': 0,
      Passed: 0,
      'Placed Out': 0,
      Review: 0,
    };

    if (item?.studentSkillsResults) {
      item?.studentSkillsResults?.map(({ key, value }) => {
        result[
          key
            ?.replace(/_/g, ' ')
            ?.toLowerCase()
            ?.replace(/\b\w/g, (char: string) => char.toUpperCase()) as SkillResultKey
        ] = value;
      });
    }

    return result;
  });
};

export const transformDataProgressSkillsTable = (data: ProgressTableSkillsValue[]): TransformedData[] => {
  return data.map(item => {
    const result: TransformedData = {
      Name: `${item?.skillName} ${item?.code}`,
      'Skill type': item?.skillType as string,
      'Not Started': 0,
      'Keep Learning': 0,
      'Almost There': 0,
      Passed: 0,
      'Placed Out': 0,
      Review: 0,
    };

    if (item?.skillsResults) {
      item?.skillsResults?.map(({ key, value }) => {
        result[
          key
            ?.replace(/_/g, ' ')
            ?.toLowerCase()
            ?.replace(/\b\w/g, (char: string) => char.toUpperCase()) as SkillResultKey
        ] = value;
      });
    }

    return result;
  });
};

export const exportToCsvProgressTable = async (
  values: ProgressTableStudentsValue[] | ProgressTableSkillsValue[],
  source: ProgressType,
) => {
  const transformedData =
    source === ProgressType.SKILLS
      ? transformDataProgressSkillsTable(values as ProgressTableSkillsValue[])
      : transformDataProgressStudentTable(values as ProgressTableStudentsValue[]);
  const headers = Object.keys(transformedData[0]);
  const valuesCsv = transformedData.map(set => Object.values(set));

  createAndExportCSV(headers, valuesCsv);
};
